(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/behaviors/startsubscription.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/behaviors/startsubscription.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.tur.start_subscription.behaviors.StartSubscription = svs.tur.start_subscription.behaviors.Subscription.extend({
    options() {
      return {
        entryModel: new svs.tur.start_subscription.models.StartEntry(),
        prefix: 'start'
      };
    },
    onStartSubscription(_ref) {
      let entry = _ref.entry,
        options = _ref.options,
        _ref$cancelUrl = _ref.cancelUrl,
        cancelUrl = _ref$cancelUrl === void 0 ? null : _ref$cancelUrl,
        _ref$successUrl = _ref.successUrl,
        successUrl = _ref$successUrl === void 0 ? null : _ref$successUrl,
        _ref$isNewSubOnlyBank = _ref.isNewSubOnlyBankcard,
        isNewSubOnlyBankcard = _ref$isNewSubOnlyBank === void 0 ? false : _ref$isNewSubOnlyBank;
      const internalCancelUrl = cancelUrl ? svs.utils.url.makeInternal(cancelUrl, svs.core.urlMapping.get('myGamingsSubscriptions')) : null;
      const internalSuccessUrl = successUrl ? svs.utils.url.makeInternal(successUrl, svs.core.urlMapping.get('myGamingsSubscriptions')) : null;
      this.entryModel.reset();
      this.entryModel.set({
        subscriptionEntry: entry,
        subscriptionOptions: options,
        cancelUrl: internalCancelUrl,
        successUrl: internalSuccessUrl,
        isNewSubOnlyBankcard
      });
      this.verifyUser();
    },
    onStartIsVerified() {
      this.getEntryOrAnnouncement(() => {
        const proceed = () => {
          if (this.entryModel.has('entry')) {
            if (this.entryModel.get('isNewSubOnlyBankcard') && this.entryModel.get('isPaymentTypeChanged')) {
              this.changePaymentType(() => this.triggerPrefixMethod('showRegisteredPayment'));
            } else {
              this.triggerPrefixMethod('showRegisteredPayment');
            }
          } else {
            this.triggerPrefixMethod('showConfirmSubscription');
          }
        };
        if (svs.core.detect.feature('ft-omni-3-ktt')) {
          var _this$entryModel$get, _this$entryModel$get2, _this$entryModel$get3;
          const amount = ((_this$entryModel$get = this.entryModel.get('entry')) === null || _this$entryModel$get === void 0 ? void 0 : _this$entryModel$get.amount) || ((_this$entryModel$get2 = this.entryModel.get('cardEntry')) === null || _this$entryModel$get2 === void 0 ? void 0 : _this$entryModel$get2.amount) || ((_this$entryModel$get3 = this.entryModel.get('autogiroEntry')) === null || _this$entryModel$get3 === void 0 ? void 0 : _this$entryModel$get3.amount);
          svs.tur.start_subscription.radio.request('checkSpendLimit', amount, null, this, proceed);
        } else {
          proceed();
        }
      });
    },
    onStartPaymentTypeChosen() {
      if (this.entryModel.get('isPaymentTypeChanged')) {
        this.changePaymentType();
      } else {
        this.triggerPrefixMethod('userConfirmPaymenttype');
      }
    },
    onStartUserConfirmPaymenttype() {
      if (this.entryModel.get('isAutogiro')) {
        this.triggerPrefixMethod('withAutogiro');
      } else {
        this.payWithCard();
      }
    },
    onStartWithAutogiro() {
      if (this.entryModel.get('hasActivePayChannel')) {
        this.getAutogiroInfoAndShowConfirm();
      } else {
        this.getAutogiroInfo();
      }
    },
    onStartSubscriptionDefined() {
      this.view.triggerMethod('saveTrackingFromWager', this, () => this.triggerPrefixMethod('activationSuccess', {
        triggerView: true
      }));
    },
    onStartActivationSuccess() {
      this.pollNewSubscription(() => {
        const newSubId = this.entryModel.get('newSubId');
        const successUrl = this.entryModel.get('successUrl');
        if (successUrl) {
          const url = new URL(successUrl, window.location.origin);
          url.searchParams.set('subscriptionId', newSubId);
          window.location.href = url.toString();
          return;
        }
        const subEntry = this.entryModel.get('subscriptionEntry');
        window.location.href = svs.tur.start_subscription.utils.afterSubPayRedirectUrl(subEntry, newSubId);
      });
    },
    onStartMakeCardPayment() {
      this.view.triggerMethod('saveTrackingFromWager', this, () => {
        this.view.triggerMethod('activationSuccess');
        this.makeCardPayment("".concat(window.location.protocol, "//").concat(window.location.host, "/").concat(svs.core.urlMapping.get('myGamingsSubscriptions'), "?subscriptionId=").concat(this.entryModel.get('newSubId')));
      });
    },
    changePaymentType(cb) {
      const callback = cb && typeof cb === 'function' ? cb : () => this.triggerPrefixMethod('userConfirmPaymenttype');
      svs.tur.start_subscription.radio.request('changeSubscriptionPaymentType', this.entryModel.get('paymentType'), this, callback);
    },

    onStartShowConfirmSubscription() {
      this.triggerPrefixMethod('showChoosePaymenttype');
    },
    onStartShowChoosePaymenttype() {
      svs.components.Modal.show(svs.tur.start_subscription.views.PaymentPrompt, {
        model: this.entryModel,
        context: this
      }, {
        title: 'Betala prenumeration',
        contentClass: svs.core.detect.formfactor.mobile() ? 'bg-white' : '',
        doubleWidth: true,
        rightButton: {
          visible: false
        },
        leftButton: {
          text: 'Avbryt',
          visible: true,
          callback: () => {
            const subscriptionId = this.entryModel.get('newSubId');
            const cancelUrl = this.entryModel.get('cancelUrl');
            const isHideLoader = !cancelUrl; 
            subscriptionId && svs.tur.start_subscription.radio.request('cancelSubscription', subscriptionId, this, () => {}, isHideLoader);

            const swpCheckout = svs.tur.start_subscription.radio.request('getSwedbankPayCheckoutObject', this);
            if (typeof (swpCheckout === null || swpCheckout === void 0 ? void 0 : swpCheckout.cleanUpSwedbankPayTransaction) === 'function') {
              this.triggerPrefixMethod('cancelButtonFirstPayBankcardSubscription');
              swpCheckout.cleanUpSwedbankPayTransaction();
            } else {
              this.triggerPrefixMethod('cancelButtonBeforeFirstPayBankcardSubscription');
            }

            svs.components.Modal.hide();
            if (cancelUrl) {
              svs.components.loader.show();
              svs.utils.url.navigate(cancelUrl);
            }
          }
        }
      });
    },
    onStartShowBankcardPaymenttype() {
      this.showBankcardPaymenttype(this.entryModel, this);
    },
    onStartShowRegisteredPayment() {
      this.getPaymentMethod();
    },
    getPaymentMethod() {
      this.triggerPrefixMethod('trackSelectedPaymenttype');
      if (this.entryModel.get('paymentType') === this.CONSTANTS.PAYMENT_TYPE.BANK_CARD.TYPE) {
        this.triggerPrefixMethod('showBankcardPaymenttype');
      } else {
        this.triggerPrefixMethod('paymentTypeChosen');
      }
    },
    getDialogConfirmMessage() {
      const _this$entryModel$attr = this.entryModel.attributes,
        isAutogiro = _this$entryModel$attr.isAutogiro,
        _this$entryModel$attr2 = _this$entryModel$attr.subscriptionOptions,
        weeklyCost = _this$entryModel$attr2.weeklyCost,
        numberOfBoards = _this$entryModel$attr2.numberOfBoards,
        jokerPrice = _this$entryModel$attr2.jokerPrice,
        gameDays = _this$entryModel$attr2.gameDays;
      return {
        title: 'Starta din prenumeration',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: "Prenumerationen kostar ".concat(weeklyCost, " kr/vecka och betalas m\xE5nadsvis i f\xF6rskott").concat(isAutogiro ? ' tillsvidare' : '', "."),
          align: svs.ui.dialog.message.align.CENTER
        }, {
          type: svs.ui.dialog.message.TEXT,
          text: "<strong>Antal rader:</strong> ".concat(numberOfBoards, "<br>\n            ").concat(jokerPrice ? "<strong>Joker:</strong> ".concat(jokerPrice, " kr<br>") : '', "\n            <strong>Speldag:</strong> ").concat(gameDays),
          align: svs.ui.dialog.message.align.CENTER
        }, {
          type: svs.ui.dialog.message.TEXT,
          text: "<a target=\"_blank\" href=\"".concat(svs.core.urlMapping.get('termsIntegrityHome'), "\">L\xE4s villkoren f\xF6r prenumeration</a>"),
          align: svs.ui.dialog.message.align.CENTER
        }]
      };
    },
    getDialogConfirmDefinedMessage() {
      let _this$entryModel$attr3 = this.entryModel.attributes,
        startTime = _this$entryModel$attr3.startTime,
        stopTime = _this$entryModel$attr3.stopTime,
        amount = _this$entryModel$attr3.amount;
      const _this$entryModel$attr4 = this.entryModel.attributes,
        isAutogiro = _this$entryModel$attr4.isAutogiro,
        _this$entryModel$attr5 = _this$entryModel$attr4.subscriptionOptions,
        numberOfBoards = _this$entryModel$attr5.numberOfBoards,
        jokerPrice = _this$entryModel$attr5.jokerPrice,
        gameDays = _this$entryModel$attr5.gameDays,
        weeklyCost = _this$entryModel$attr5.weeklyCost;
      startTime = svs.utils.date.FormatTime('d/M', startTime);
      stopTime = svs.utils.date.FormatTime('d/M', stopTime);
      amount = svs.utils.format.Currency(amount);
      return {
        title: "Prenumeration med ".concat(this.entryModel.get('paymentTypeText')),
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: "Prenumerationen kostar ".concat(weeklyCost, " kr/vecka och betalas m\xE5nadsvis i f\xF6rskott").concat(isAutogiro ? ' tillsvidare' : '', "."),
          align: svs.ui.dialog.message.align.CENTER
        }, {
          type: svs.ui.dialog.message.TEXT,
          text: "<strong>Antal rader:</strong> ".concat(numberOfBoards, "<br>\n              ").concat(jokerPrice ? "<strong>Joker:</strong> ".concat(jokerPrice, " kr<br>") : '', "\n              <strong>Speldag:</strong> ").concat(gameDays),
          align: svs.ui.dialog.message.align.CENTER
        }, {
          type: svs.ui.dialog.message.TEXT,
          text: "F\xF6r startperioden ".concat(startTime, " - ").concat(stopTime, " \xE4r totala kostnaden ").concat(amount, " kr").concat(isAutogiro ? " och dras prelimin\xE4rt den ".concat(startTime) : '', ". Spel under denna period kan inte annulleras."),
          align: svs.ui.dialog.message.align.CENTER
        }]
      };
    }
  });
})(Backbone, _, svs);

 })(window);